import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

interface SmartArchiveDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  itemName: string;
  linkedSummary: string;
  onArchive: () => void;
  isArchiving: boolean;
}

/**
 * Shown when a document has linked transactions and cannot be permanently deleted.
 * Offers archive (disabled=1) as the only option. Archive button is primary blue (safe action).
 */
export function SmartArchiveDialog({
  open,
  onOpenChange,
  itemName,
  linkedSummary,
  onArchive,
  isArchiving,
}: SmartArchiveDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="text-lg font-semibold">
            Can&apos;t permanently delete &ldquo;{itemName}&rdquo;
          </DialogTitle>
          <DialogDescription className="text-sm text-muted-foreground">
            This product has {linkedSummary} linked to it. It will be archived
            instead — hidden from your lists but always recoverable.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isArchiving}
          >
            Cancel
          </Button>
          <Button onClick={onArchive} disabled={isArchiving}>
            {isArchiving && <Loader2 className="size-4 mr-2 animate-spin" />}
            {isArchiving ? "Archiving..." : "Archive"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
